/**
 * Mock PubSub Metadata Implementation (STUB)
 *
 * NOTE: This is temporarily stubbed out during Stanza.js migration.
 * Full PubSub implementation will be added later.
 */
// ============================================================================
// Mock PubSub Metadata Implementation (STUB)
// ============================================================================
export class MockPubSubMetadata {
    constructor(backend) {
        this._backend = backend;
    }
    // ===== Game Operations =====
    async getGame() {
        return null;
    }
    async setGame(_game) {
        // Stubbed
    }
    async getGameTheme() {
        return null;
    }
    async setGameTheme(_theme) {
        // Stubbed
    }
    async subscribeGame(_callback) {
        // Stubbed
    }
    async subscribeGameTheme(_callback) {
        // Stubbed
    }
    // ===== Force Operations =====
    async getForces() {
        return [];
    }
    async getForce(_forceId) {
        return null;
    }
    async setForce(_force) {
        // Stubbed
    }
    async deleteForce(_forceId) {
        // Stubbed
    }
    async subscribeForces(_callback) {
        // Stubbed
    }
    // ===== Room Extension Operations =====
    async getRoomExtensions() {
        return [];
    }
    async getRoomExtension(_roomJid) {
        return null;
    }
    async setRoomExtension(_extension) {
        // Stubbed
    }
    async subscribeRoomExtensions(_callback) {
        // Stubbed
    }
    async archiveRoomExtension(_roomJid) {
        // Stubbed
    }
    // ===== Form Schema Operations =====
    async getFormSchemas() {
        return [];
    }
    async getFormSchema(_schemaId) {
        return null;
    }
    async setFormSchema(_schema) {
        // Stubbed
    }
    async deleteFormSchema(_schemaId) {
        // Stubbed
    }
    async subscribeFormSchemas(_callback) {
        // Stubbed
    }
    // ===== Cleanup =====
    async unsubscribeAll() {
        // Stubbed
    }
}
//# sourceMappingURL=mock-pubsub.js.map